import React from 'react'
import { Link } from 'react-router-dom'
export default function Footer() {
    return (

        <>

            <footer className="main-footer">
                <div className="pattern-layer" />
                <div className="auto-container">
                    <div className="widgets-section">
                        <div className="row clearfix">
                            <div className="footer-column col-12 col-sm-12 col-md-12 col-lg-4">
                                <div className="footer-widget logo-widget">
                                    <div className="logo">
                                        <Link className="d-none d-lg-block d-xl-block d-md-none " to="/"><img src="/assets/images/logo-asraweb.svg" alt /></Link>
                                        <Link className="d-block d-sm-block d-lg-none" to="/"><img src="/assets/images/logo-white.svg" alt /></Link>
                                    </div>
                                    <div className="quick-links__container d-block d-sm-block d-lg-none">
                                        <ul>
                                            <li><Link to="/about-us">درباره ما</Link></li>
                                            <li><Link to="/projects">نمونه کارها</Link></li>
                                            <li><Link to="/contact-us">تماس با ما</Link></li>
                                        </ul>
                                        <p className="copyright">
                                            کلیه حقوق این وبسایت محفوظ و متعلق به گروه اسراوب می باشد.
                                        </p>
                                    </div>
                                    <div className="text d-none d-lg-block d-xl-block d-md-none">یک تیم مشتکل از تجارب و تخصص
                                        های مختلف که برای
                                        موفقیت خود و شما تمام
                                        توان خود را
                                        به کار می گیرد.
                                    </div>
                                    <ul className="social-box d-none d-lg-block d-xl-block d-md-none">
                                        <li className="share">ما در شبکه های اجتماعی دنبال کنید</li>
                                        <li className="instagram"><a target="_blank" href="http://instagram.com/asrawebco" className="fa fa-instagram" /></li>
                                        <li className="telegram"><a target="_blank" href="http://telegram.com/asrawebco" className="fa fa-telegram" /></li>
                                        <li className="linkedin"><a target="_blank" href="https://www.linkedin.com/company/asrawebco" className="fa fa-linkedin" /></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="footer-column col-12 col-sm-6 col-md-6 col-lg-4">
                                <div className="footer-widget links-widget">
                                    <h4 className="dark">دسترسی های سریع</h4>
                                    <div className="d-block d-sm-block d-lg-none">
                                        <div className="row clearfix">
                                            <div className="column col-12">
                                                <ul className="quick-actions">
                                                    <li>
                                                        <Link to="/request-consulting">
                                                            <div className="icon-container">
                                                                <i className="flaticon flaticon-meeting red" />
                                                            </div>
                                                            <span>درخواست وقت مشاوره</span>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <a className="disabled">
                                                            <div className="icon-container">
                                                                <i className="flaticon flaticon-team red" />
                                                            </div>
                                                            <span>پورتال مشتریان</span>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a className="disabled">
                                                            <div className="icon-container">
                                                                <i className="flaticon flaticon-bussiness red" />
                                                            </div>
                                                            <span>فرصت های شغلی</span>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <Link to="/projects">
                                                            <div className="icon-container">
                                                                <i className="flaticon flaticon-presentation red" />
                                                            </div>
                                                            <span>نمونه کارها</span>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-none d-lg-block d-xl-block d-md-none">
                                        <div className="row clearfix">
                                            <div className="column col-lg-6 col-md-6 col-sm-12">
                                                <ul className="list-link">
                                                    <li><Link to="/">صفحه اصلی</Link></li>
                                                    <li><Link to="/services">خدمات ما</Link></li>
                                                    <li><Link to="/about-us">درباره ما</Link></li>
                                                    <li><Link to="/projects">نمونه کارها</Link></li>
                                                    <li><a className="disabled">وبلاگ(بزودی)</a></li>
                                                    <li><Link to="/contact-us">تماس با ما</Link></li>
                                                </ul>
                                            </div>
                                            <div className="column col-lg-6 col-md-6 col-sm-12">
                                                <ul className="list-link">
                                                    <li><Link to="/faqs">سوالات متداول</Link></li>
                                                    <li><a target="_blank" href="https://t.me/asrawebco">تلگرام اسراوب</a>
                                                    </li>
                                                    <li><a target="_blank" href="https://wa.me/15551234567">واتس آپ کاری</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="footer-column col-12 col-sm-6 col-md-6 col-lg-4">
                                <div className="footer-widget contact-widget">
                                    <h4>اطلاعات تماس</h4>
                                    <h6>در تماس باشید</h6>
                                    <ul className="list-style-two">
                                        <li><span className="icon flaticon flaticon-pin" />
                                            <a href="https://goo.gl/maps/iQTeG3PFqFw3Z6f69" target="_blank">
                                                مشهد، بلوار استقلال، جنب میدان
                                                معلم، پلاک ۶۲
                                            </a>
                                        </li>
                                        <li><span className="icon flaticon flaticon-telephone" /><a href="tel:+985136076022">05136076022</a></li>
                                        <li><span className="icon flaticon flaticon-envelope" /><a href="mailto:info@asraweb.com">info@asraweb.com</a></li>
                                    </ul>
                                    <h6>ساعات کار</h6>
                                    <div className="timing">پنجشنبه - شنبه 09:00 صبح تا 05:00 بعد از ظهر</div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="auto-container">
                        <div className="row clearfix">
                            <div className="column col-12 col-sm-12 col-md-12 col-lg-6">
                                <div className="copyright d-none d-lg-block d-xl-block d-sm-none d-md-none">تمام حقوق این وب سایت برای
                                    گروه اسراوب محفوظ است.
                                </div>
                            </div>
                            <div className="column col-12 col-sm-12 col-md-12 col-lg-6">
                                <ul className="footer-nav">
                                    <li><Link to="/privacy-policy">سیاست حفظ حریم خصوصی</Link></li>
                                    <li><Link to="/terms-of-use"> شرایط استفاده</Link></li>
                                </ul>
                                <ul className="custome-social-box text-center d-block d-sm-block d-lg-none">
                                    <li className="instagram"><a target="_blank" href="http://instagram.com/asrawebco" className="fa fa-instagram" /></li>
                                    <li className="telegram"><a target="_blank" href="http://t.me/asraweb" className="fa fa-telegram" /></li>
                                    <li className="linkedin"><a target="_blank" href="https://www.linkedin.com/company/asrawebco" className="fa fa-linkedin" /></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            <a id="totop" href="#top">
                <i className="fa fa-angle-up" />
            </a>

        </>
    )
}
